import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'
import ListItem from '@material-ui/core/ListItem'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'

import Avatar from '../../../../common/Avatar'

import styles from './styles'

const Item = ({ connection, history, classes }) => {
  return (
    <ListItem
      key={connection.id}
      className={classes.listItem}
      button
      onClick={() => history.push(`/brands/${connection.id}`)}
    >
      <Avatar
        className={classes.avatar}
        title={connection.name}
        source={connection.logoUrl}
      />
      <ListItemText
        className={classes.businessName}
        primary={<Typography variant="subtitle1">{connection.name}</Typography>}
        secondary={connection.type}
      />
      <ListItemSecondaryAction>
        <IconButton disabled color="primary" size="small">
          <NavigateNextIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  )
}

export default withStyles(styles)(withRouter(Item))



// WEBPACK FOOTER //
// ./src/components/listings/Page/Brands/Item/index.js